export default __webpack_public_path__ + "static/media/LO05.e8e4e551.mp3";